export const validatePhone = (phone: string): boolean => {
  const emailRegex = /^\(\d{2}\) \d{5}-\d{4}$/

  if (phone?.length) {
    return Boolean(phone?.match(emailRegex))
  }
}
